module.exports = __webpack_public_path__ + "img/about-m-slide-21.12bd7bf9.jpg";